import { Paper } from '@trackman/web-shared-components';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import { SessionStore } from 'stores/SessionStore';
import { SessionMode } from 'enums/SessionMode';
import { SectionHeadline } from 'pages/Tagging/components/SectionHeadline/SectionHeadline';
import { BpTaggingStore } from 'stores/Tagging/BpTaggingStore';
import { BpPlay } from 'models/tagging/BpPlay';
import { BpPlayComponent } from './BpPlayComponent/BpPlayComponent';
import { BpPlaceholderPlay } from './BpPlaceholderPlay';
import {
  BpPlayListPlaceholder,
  BpPlayListWrapper,
  LowerLabel,
  PlaceholderCard,
  PlaceholderText,
  ScoreLabel,
  UpperLabel,
} from './BpPlayListStyles';

const BpPlayList: React.FC = observer(() => {
  const taggingStore = useInjection<BpTaggingStore>(ServiceTypes.BpTaggingStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);

  const renderPlay = (play: BpPlay, index: number) => {
    if (play.isPlaceholder) {
      return (
        <BpPlaceholderPlay
          key={index}
          isHidden={!taggingStore.shouldDisplayPlaceholder}
          play={play}
          onClick={(p: BpPlay) => {
            taggingStore.selectedPlay = p;
          }}
          isSelected={!!taggingStore.selectedPlay && taggingStore.selectedPlay.id === play.id}
        />
      );
    }
    return (
      <BpPlayComponent
        play={play}
        onClick={(p: BpPlay) => {
          taggingStore.selectedPlay = p;
        }}
        key={play.id}
        isSelected={play.id === (taggingStore.selectedPlay ? taggingStore.selectedPlay.id : undefined)}
        dataTest={`bp-play-tile-${index}`}
      />
    );
  };

  const renderPlaceholder = () => {
    if (taggingStore.playCount === 0 && sessionStore.currentSessionMode.sessionMode !== SessionMode.PlayingStarted) {
      return (
        <BpPlayListPlaceholder>
          <PlaceholderCard>
            <UpperLabel />
            <ScoreLabel>122 mph</ScoreLabel>
            <LowerLabel />
          </PlaceholderCard>
          <PlaceholderCard>
            <UpperLabel />
            <ScoreLabel>108 mph</ScoreLabel>
            <LowerLabel />
          </PlaceholderCard>
          <PlaceholderText>Incoming plays will be displayed here</PlaceholderText>
        </BpPlayListPlaceholder>
      );
    }
  };

  return (
    <BpPlayListWrapper>
      <SectionHeadline>
        <span>{taggingStore.playCount} hits</span>
      </SectionHeadline>
      <Paper padding='5px' className='tagging-column'>
        <>
          {taggingStore.displayPlays.map(renderPlay)}
          {renderPlaceholder()}
        </>
      </Paper>
    </BpPlayListWrapper>
  );
});

export default BpPlayList;
